export default "__VITE_ASSET__BVTsPqvx__"